import React from "react";

function NirbhikContent({ content, showTitlePanel = true }) {
  const lines = content.split(/\r?\n/);
  const title = lines[0] || "";
  const bodyLines = lines.slice(1);

  const renderLine = (line, index) => {
    if (line === "") {
      return <div key={index} className="nirbhik-gap" />;
    }

    if (/^\d+\.\s/.test(line)) {
      return (
        <h3 key={index} className="nirbhik-heading">
          {line}
        </h3>
      );
    }

    if (line.startsWith('"') || line.endsWith('"')) {
      return (
        <blockquote key={index} className="nirbhik-quote">
          {line}
        </blockquote>
      );
    }

    return (
      <p key={index} className="nirbhik-paragraph">
        {line}
      </p>
    );
  };

  return (
    <article className="nirbhik-article">
      {showTitlePanel && (
        <div className="nirbhik-title-panel">
          <div className="nirbhik-title-icon">
            <i className="fas fa-shield-halved"></i>
          </div>
          <h2>{title}</h2>
        </div>
      )}

      <div className="nirbhik-body">{bodyLines.map(renderLine)}</div>
    </article>
  );
}

export default NirbhikContent;
